import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { DataTable, Field } from '../../commons/DataTable';
import ModalNoInsurance from './ModalNoInsurance';
import ModalPanoramicaInsurance from './ModalPanoramicaInsurance';

function InsurancesByMonthTable(props) {
  const {
    data = [],
    query = {},
    onFilter = () => {},
    onNoInsuranceConfirm = () => {},
    fetchTotalInsurances = () => {},
    total,
  } = props;
  const [t] = useTranslation('COMMON');

  return (
    <DataTable
      history
      data={data}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      offset={query.offset}
      limit={query.limit}
      onFilter={onFilter}
      total={total}
    >
      <Field
        className="txt-table-left"
        title="Fornitore"
        source="businessName"
      />
      <ModalPanoramicaInsurance
        title="Gennaio"
        month={1}
        year={query.year}
        source="months[0].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Febbraio"
        month={2}
        year={query.year}
        source="months[1].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Marzo"
        month={3}
        year={query.year}
        source="months[2].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Aprile"
        month={4}
        year={query.year}
        source="months[3].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Maggio"
        month={5}
        year={query.year}
        source="months[4].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Giugno"
        month={6}
        year={query.year}
        source="months[5].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Luglio"
        month={7}
        year={query.year}
        source="months[6].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Agosto"
        month={8}
        year={query.year}
        source="months[7].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Settembre"
        month={9}
        year={query.year}
        source="months[8].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Ottobre"
        month={10}
        year={query.year}
        source="months[9].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Novembre"
        month={11}
        year={query.year}
        source="months[10].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalPanoramicaInsurance
        title="Dicembre"
        month={12}
        year={query.year}
        source="months[11].count"
        fetchTotalInsurances={fetchTotalInsurances}
      />
      <ModalNoInsurance
        onConfirm={onNoInsuranceConfirm}
        year={query.year}
        fetchTotalInsurances={fetchTotalInsurances}
      />
    </DataTable>
  );
}

export default withRouter(InsurancesByMonthTable);
